import { render, staticRenderFns } from "./StockPageImport.vue?vue&type=template&id=5da83d40&scoped=true&"
import script from "./StockPageImport.vue?vue&type=script&lang=js&"
export * from "./StockPageImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da83d40",
  null
  
)

export default component.exports